module.exports = __webpack_public_path__ + "static/img/report_legend_01.c287d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report_legend_01.png
// module id = ej6v
// module chunks = 38